import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEisSpezialitaeten = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#eis-spezialitaeten_svg__a)">
      <path
        fill="#263E6A"
        d="M11.562 10.59h3.79a.25.25 0 0 1 .247.254.25.25 0 0 1-.246.254h-4.026l-.025.003q-.013 0-.026-.003h-3.66l-.025.003H7.5c.113 2.068 1.584 3.81 3.583 4.196a.25.25 0 0 1 .201.25v2.076c0 .11-.069.207-.17.241-.392.133-.699.36-.862.629h3.293c-.163-.268-.47-.496-.863-.629a.25.25 0 0 1-.17-.241v-2.077c0-.122.085-.227.202-.25 1.865-.359 3.291-1.898 3.549-3.83a.247.247 0 0 1 .278-.217c.135.02.23.147.21.286-.276 2.079-1.77 3.75-3.745 4.218v1.692c.622.259 1.043.718 1.142 1.255a.26.26 0 0 1-.053.209.24.24 0 0 1-.19.092H9.893a.24.24 0 0 1-.19-.092.26.26 0 0 1-.053-.21c.098-.536.52-.995 1.141-1.254v-1.692c-2.205-.524-3.785-2.55-3.79-4.897v-.005L7 10.844C7 9.214 8.288 7.89 9.872 7.89c.532 0 1.051.151 1.502.437.117.073.153.23.081.35a.243.243 0 0 1-.34.082 2.3 2.3 0 0 0-1.243-.36c-1.228 0-2.242.962-2.366 2.192h3.56c.11-1.34 1.08-2.439 2.39-2.661a2.8 2.8 0 0 1 .722-.028c-.294-1.021-1.218-1.755-2.276-1.755-.868 0-1.666.487-2.084 1.271a.243.243 0 0 1-.335.101.26.26 0 0 1-.098-.345 2.86 2.86 0 0 1 2.517-1.535c1.361 0 2.538 1.005 2.808 2.364a2.94 2.94 0 0 1 2.063 2.45.253.253 0 0 1-.245.287.25.25 0 0 1-.244-.22c-.156-1.21-1.17-2.122-2.357-2.122q-.198 0-.39.033c-1.07.182-1.867 1.07-1.975 2.16m6.345-6.534a.24.24 0 0 0-.347.04l-2.477 3.206a.26.26 0 0 0 .04.357.24.24 0 0 0 .346-.041l2.477-3.205a.26.26 0 0 0-.04-.357"
      />
    </g>
    <defs>
      <clipPath id="eis-spezialitaeten_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgEisSpezialitaeten;
